import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const getDemandLoans = async (
    pageParams: number,
    id: string | undefined
) => {
    const { data }: { data: IDemandLoans } = await request.get(
        `/api/v1/moneypools/${id}/loan-demands/?page=${pageParams}`
    )
    return data
}
export const getAcceptedDemandLoans = async (
    pageParams: number,
    id: string | undefined
) => {
    const { data }: { data: IAcceptedDemandLoans } = await request.get(
        `/api/v1/moneypools/${id}/loan-demands/?states=acpd&reverse=true&order_bys=acceptance_datetime&page=${pageParams}`
    )
    return data
}

export const getRejectedDemandLoans = async (
    pageParams: number,
    id: string | undefined
) => {
    const { data }: { data: IRejectedDemandLoans } = await request.get(
        `/api/v1/moneypools/${id}/loan-demands/?states=cnld%2Crjcd&order_bys=rejection_datetime&page=${pageParams}`
    )
    return data
}

export const deleteRequestedLoan = async ({
    id,
    loanId,
}: {
    id: string | undefined
    loanId: number
}) => {
    const response = await request.delete(
        `/api/v1/moneypools/${id}/loan-demands/${loanId}/`
    )
    return response
}

export const getCards = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IGetCardsData } = await request.post(
        '/api/v1/payment/init/?os_type=android&app_version=1.892.4',
        [
            {
                id: ctx.queryKey[1],
                type: 'psp',
                amount: 0,
                cashin_type: 'cnp',
                paid_obj_id: 0,
            },
        ]
    )
    return data
}

export const AddRequestedLoan = async (payload: IAddRequestedLoadServise) => {
    const { data } = await request.post(
        `api/v1/moneypools/${payload.id}/loan-demands/`,
        {
            amount: payload.amount,
            num_repayments: payload.num_repayments,
            demand_priority: payload.demand_priority,
            user_description: payload.user_description,
            selected_card_number: payload.selected_card_number,
            poolship_id: payload.poolship_id,
            proposed_guarantors: payload.proposed_guarantors ?? [],
        }
    )
    return data
}

export const initTransaction = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IInitTransaction } = await request.post(
        '/api/v1/payment/init/?os_type=android&app_version=1.891.1',
        [
            {
                id: ctx.queryKey[1],
                type: 'mbr',
                amount: 0,
                cashin_type: 'hwt',
                paid_obj_id: 0,
            },
        ]
    )
    return data
}

export const initTransactionForOthers = async (
    id: number,
    amount: number
): Promise<IInitTransaction> => {
    const { data } = await request.post(
        '/api/v1/payment/init/?os_type=android&app_version=1.892.12',
        [
            {
                id,
                type: 'psp',
                amount,
                cashin_type: 'cnp',
                paid_obj_id: 0,
            },
        ]
    )
    return data
}

export const initTransactionForOthersLoans = async (
    ctx: QueryFunctionContext
) => {
    const { data }: { data: IInitTransaction } = await request.post(
        '/api/v1/payment/init/?os_type=android&app_version=1.892.31',
        [
            {
                id: ctx.queryKey[1],
                type: 'psp',
                amount: ctx.queryKey[2],
                cashin_type: 'cnr',
                paid_obj_id: ctx.queryKey[3],
            },
        ]
    )
    return data
}

export const cashin = async (ctx: QueryFunctionContext) => {
    const { data }: { data: CashinTypes } = await request.post(
        `/api/v1/payment/moneypools/${ctx.queryKey[5]}/moneypool-cashins/`,
        [
            {
                poolship: ctx.queryKey[1],
                amount: ctx.queryKey[2],
                type: ctx.queryKey[3],
                tag: ctx.queryKey[4],
                transaction: {
                    ctx_id: ctx.queryKey[5],
                    ctx_type: 'mnp',
                    destination: ctx.queryKey[6],
                    gateway: ctx.queryKey[7],
                    is_group_pay: false,
                    payer_name: '',
                    receiver: ctx.queryKey[8],
                    receiver_name: '',
                    source: 'gtw',
                    state: '',
                    state_time: '',
                    transaction_code: '',
                },
            },
        ]
    )
    return data
}

export const cashinForMng = async (payload: IFuckingPayload) => {
    const { data }: { data: CashinTypes } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/moneypool-cashins/`,
        [
            {
                poolship: payload.poolship,
                amount: payload.amount,
                type: payload?.type,
                tag: '',
            },
        ]
    )
    return data
}

export const getSubHeaderLoans = async (ctx: QueryFunctionContext) => {
    const { data }: { data: ISubHeaderLoans } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/loans/?poolship_id=${ctx.queryKey[2]}&page=${ctx.queryKey[3]}`
    )
    return data
}
